import { AgGridReact } from 'ag-grid-react';
import { themeBalham } from 'ag-grid-enterprise';
import { ColDef } from 'ag-grid-community';
import { TSummaryMsiValue, TSummaryMsiValueItem } from '../valueTypes';
import { useMemo, useRef } from 'react';
import { formatValueAsString } from '../../../utils/helpers';
import InfoNote from '../../common/SharedComponents/Info-Note';
import DynamicTab from '../../../shared/components/tabs/DynamicTab';

export interface ISummaryMsiValue {
	summaryMsiValue: TSummaryMsiValue | null;
}

const SummaryMsiValue: React.FC<ISummaryMsiValue> = ({ ...props }) => {
	const gridRef = useRef<any>(null);

	const options: Intl.NumberFormatOptions = { minimumFractionDigits: 0, maximumFractionDigits: 1 };

	const defaultColDef = useMemo<ColDef>(() => {
		return {
			flex: 1,
			//filter: 'agTextColumnFilter',
		};
	}, []);

	const colDefs: ColDef<TSummaryMsiValueItem>[] = [
		{
			headerName: 'Sector',
			field: 'sector',
			cellStyle: (params) =>
				params.value === 'Total'
					? { backgroundColor: '#eeeeee', fontWeight: 'bold', color: 'black' }
					: { backgroundColor: '#eeeeee', fontWeight: 'normal', color: 'black' },
			aggFunc: () => 'Total',
		},
		{
			headerName: '# Ships',
			field: 'ships',
			valueFormatter: (params: any) => formatValueAsString(params.data?.ships),
		},
		{
			headerName: 'Average Size',
			field: 'averageSize',
			valueFormatter: (params: any) =>
				formatValueAsString(params.data?.averageSize, options, '', '', ' ' + params.data?.sizeUnit),
		},
		{
			headerName: 'Average Age',
			field: 'averageAge',
			valueFormatter: (params: any) => formatValueAsString(params.data?.averageAge, options),
		},
		{
			headerName: 'Current Value ($ Mn)',
			field: 'fairMarketValue',
			cellStyle: { backgroundColor: '#3785BF', color: 'white' },
			valueFormatter: (params: any) => formatValueAsString(params.value, options),
			aggFunc: () => {
				const totalFairMarketValue = rowData.reduce(
					(sum, vessel) => sum + (!Number.isNaN(vessel.fairMarketValue) ? vessel.fairMarketValue : 0),
					0,
				);
				return totalFairMarketValue;
			},
		},
	];

	const onGridReady = (params: any) => {
		gridRef.current = params.api;
		gridRef.current!.sizeColumnsToFit();
	};

	const rowData = props.summaryMsiValue?.dataList ? props.summaryMsiValue.dataList : [];

	const tabs = useMemo(
		() => [
			{
				id: 'overview',
				label: 'Overview',
				content: (
					<div className="flex flex-col w-full h-full">
						<div className="w-full h-full">
							<AgGridReact
								ref={gridRef}
								onGridReady={onGridReady}
								defaultColDef={defaultColDef}
								columnDefs={colDefs}
								rowData={rowData}
								theme={themeBalham}
								grandTotalRow={'bottom'}
							/>
						</div>
						<div className="mt-4">
							<InfoNote />
						</div>
					</div>
				),
			},
		],
		[rowData, colDefs],
	);

	return <DynamicTab items={tabs} tabColor="msi-midblue-color-500" />;
};

export default SummaryMsiValue;
